<template>
    <Dialog :mask="true" :extra="true" onlyOK class="feedback" @close="closeThis">
        <div slot="title" class="feedback-title">
            <img src="@/home/assets/img/tinylogo.svg" alt="" />
            <span class="label">模板需求反馈</span>
        </div>

        <div class="feedback-content">
            <p class="notify">
                找不到您想要的模板？您可以将您所需要的模板类型告诉我们。请详细填写下面的反馈给我们，若需求准确，我们将第一时间为您更新。
            </p>
            <Form :model="feedbackForm" hide-required-asterisk :rules="feedbackRules" :lock-scroll="false" ref="feedbackForm" label-position="top">
                <FormItem label="请填写您需要的模板类型" prop="type" class="item-type">
                    <Input v-model="feedbackForm.type" placeholder="例：流程图、思维导图" />
                </FormItem>
                <FormItem label="填写行业" prop="company" class="item-industry">
                    <Input v-model="feedbackForm.company" placeholder="行业" />
                </FormItem>
                <FormItem label="填写职业" prop="profession" class="item-occupation">
                    <Input v-model="feedbackForm.profession" placeholder="职业" />
                </FormItem>
                <FormItem label="描述您的需求" prop="description" class="item-demand">
                    <Input
                        :rows="6"
                        type="textarea"
                        v-model="feedbackForm.description"
                        :maxlength="500"
                        show-word-limit
                        placeholder="详细的描述有助于我们更快设计满足您需求的模板"
                    />
                </FormItem>
                <FormItem label="添加相关设计参考（最多可添加三张）">
                    <div class="demo-upload-list" v-for="(item, index) in feedbackForm.fileList">
                        <img :src="getUrl(item)" />
                        <div class="demo-upload-list-cover">
                            <Icon type="ios-trash-outline" @click.native="handleRemove(index)"></Icon>
                        </div>
                    </div>
                    <Upload
                        v-show="feedbackForm.fileList.length < 3"
                        ref="upload"
                        :class="{ hide: hideUpload }"
                        :before-upload="handleUpload"
                        accept=".jpeg,.jpg,.png"
                        :limit="limitCount"
                        multiple
                        action=""
                    >
                        <Icon type="ios-add" size="20"></Icon>
                    </Upload>
                </FormItem>
            </Form>
        </div>

        <div class="feedback-footer">
            <Button class="feedback-btn" @click="submitFeedback" :loading="loading">提交需求</Button>
        </div>
    </Dialog>
</template>

<script>
    import Compressor from "compressorjs";
    import Dialog from "./Dialog";
    export default {
        components: {
            Dialog,
        },
        data() {
            const validate = (label, limit, rule, value, callback) => {
                if (!value.trim()) {
                    return callback(new Error(`（*未填写${label}）`));
                } else if (value.length > limit) {
                    return callback(new Error(`字数应小于${limit}个`));
                } else {
                    return callback();
                }
            };

            return {
                feedbackForm: {
                    type: "",
                    company: "",
                    profession: "",
                    description: "",
                    fileList: [],
                },
                feedbackRules: {
                    type: [
                        {
                            validator: (...rest) => validate("模板图形类型", 50, ...rest),
                            trigger: "blur",
                        },
                    ],
                    company: [
                        {
                            validator: (...rest) => validate("行业", 50, ...rest),
                            trigger: "blur",
                        },
                    ],
                    profession: [
                        {
                            validator: (...rest) => validate("职业", 50, ...rest),
                            trigger: "blur",
                        },
                    ],
                    description: [
                        {
                            validator: (...rest) => validate("需求描述", 500, ...rest),
                            trigger: "blur",
                        },
                    ],
                },
                hideUpload: false,
                limitCount: 3,
                loading: false,
            };
        },

        methods: {
            submitFeedback() {
                this.$refs.feedbackForm.validate(async (pass) => {
                    try {
                        if (!pass) return false;
                        this.loading = true;
                        const { type, company, profession, description, fileList } = this.feedbackForm;

                        if (fileList && fileList.length) {
                            const ossData = await this.$edApi.geUploadLink();
                            // 压缩图片队列
                            const compressList = fileList.map((f) => {
                                return new Promise((rs, rj) => {
                                    new Compressor(f, {
                                        quality: 0.6,
                                        convertSize: 5 * 1024 * 1024,
                                        success(result) {
                                            rs(result);
                                        },
                                        error(err) {
                                            rj(err);
                                        },
                                    });
                                });
                            });

                            const compressFile = await Promise.all(compressList);
                            //上传图片队列
                            let uploadList = compressFile.map((compressItem, i) => {
                                let imgform = new FormData();
                                imgform.append("OSSAccessKeyId", ossData.id);
                                imgform.append("policy", ossData.policy);
                                imgform.append("Signature", ossData.sign);
                                imgform.append("key", ossData.path + `images${i}`);
                                imgform.append("file", compressItem);

                                return new Promise((rs, rj) => {
                                    let param = {
                                        url: ossData.host,
                                        data: imgform,
                                    };
                                    this.$edApi.uploadFile(param).then((res) => {
                                        rs();
                                    });
                                });
                            });

                            await Promise.all(uploadList);
                            // 提交反馈到后台
                            await this.$edApi.submitFeedback({
                                type,
                                company,
                                profession,
                                description,
                                image_num: fileList.length,
                                image_path: ossData.path,
                            });
                            this.$edMessage.success("提交成功");
                            //this.showFeedback = false;
                            this.closeThis();
                            this.loading = false;
                        } else {
                            // 无图片提交
                            await this.$edApi.submitFeedback({
                                type,
                                company,
                                profession,
                                description,
                            });
                            this.$edMessage.success("提交成功");
                            // this.showFeedback = false;
                            this.closeThis();
                            this.loading = false;
                        }
                    } catch (error) {
                        let status = error.response.status;
                        this.$edMessage.error(status == 422 ? "提交信息中包含敏感词汇，请您更正！" : "提交失败");
                        this.loading = false;
                    }
                });
            },

            handleRemove(index) {
                this.feedbackForm.fileList.splice(index, 1);
            },
            handleUpload(file) {
                const isLt15M = file.size / 1024 / 1024 < 15;
                if (!isLt15M) {
                    this.$edMessage.error("最大上传大小为15M");
                    return;
                }
                if (this.feedbackForm.fileList.length >= 3) {
                    this.$edMessage.error("最多3张图片");
                    return;
                }
                this.feedbackForm.fileList.push(file);
                return false;
            },
            getUrl(file) {
                return URL.createObjectURL(file);
            },
            closeThis() {
                this.$store.commit("setDialogState", {
                    type: "showDialog",
                    data: false,
                });
            },
        },
    };
</script>

<style lang="stylus">
    .feedback {
      display: flex;
      flex-direction: column;
      width: 620px;

      .feedback-title {
        margin-top: 12px;
        display: flex;
        align-items: center;

        .label {
          font-size: 12px;
          font-weight: bold;
          margin-left: 5px;
        }
      }
      .ivu-input{
          font-size: 12px;
      }

      .feedback-content {
        padding: 16px 34px;
        @media screen and (max-height: 700px) {
            height 400px
            overflow overlay
        }

        .notify {
          margin-bottom: 17px;
          color: #999999;
          font-size: 12px;
        }

        .ivu-form-item {
          position: relative;
          margin-bottom: 16px;


          .ivu-form-item-label{
            color: #000  !important;
            font-size: 12px;
          }

          .ivu-form-item__content {
            line-height: unset;
            position: static;
          }

          .ivu-form-item-error {
            top: -2px;
          }



        }

        .item-type {
          .ivu-form-item-error-tip {
            top: -28px;
            left: 140px;
          }
        }

        .item-industry {
          .ivu-form-item-error-tip {
            top: -28px;
            left: 56px;
          }
        }

        .item-occupation {
          .ivu-form-item-error-tip {
            top: -28px;
            left: 56px;
          }
        }

        .item-demand {
          .ivu-form-item-error-tip {
            top: -28px;
            left: 80px;
          }
        }
      }

      .feedback-footer {
        text-align: center;
        padding: 10px 20px 20px;
        padding-bottom: 10px;
        .feedback-btn {
          padding: 6px 35px;
          background: #037FFF;
          outline: none;
          border-radius: 2px;
          color: #fff;
          border: 0;
          cursor: pointer;
          font-size: 12px;
          line-height: unset;
        }
      }

        .demo-upload-list{
            width: 80px;
            height: 80px;
            overflow: hidden;
            background-color: #fff;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            box-sizing: border-box;
            margin: 0 8px 0px 0;
            display: inline-block;
            position: relative;
            text-align: center;
        }
        .demo-upload-list img{
            width: 100%;
            height: 100%;
        }
        .demo-upload-list-cover{
            display: none;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0,0,0,.6);
        }
        .demo-upload-list:hover .demo-upload-list-cover{
            display: block;
        }
        .demo-upload-list-cover:after {
            display: inline-block;
            content: "";
            height: 100%;
            vertical-align: middle;
        }
        .demo-upload-list-cover i{
            vertical-align:middle;
            color: #fff;
            font-size: 20px;
            cursor: pointer;
            margin: 0 2px;
        }
        .ivu-upload-select{
            width: 80px;
            height: 80px;
            overflow: hidden;
            background-color: #fff;
            border: 1px dashed #c0ccda;
            border-radius: 6px;
            box-sizing: border-box;
            margin: 0 8px 0px 0;
            display: inline-block;
            position: relative;
            text-align: center;
        }
        .ivu-upload-select:after {
            display: inline-block;
            content: "";
            height: 100%;
            vertical-align: middle;
        }
        .ivu-upload-list{
            display:none;
        }
        .ivu-upload{
            display: inline-block;
        }
        .ivu-upload-select i{
            font-size: 40px !important;
            color: #8c939d;
            vertical-align: middle;
        }
    }
</style>
